import EducationSectorCodebookContainer from '@src/components/codebook/EducationSectorCodebookContainer';
import withLocalize, { IWithLocalizeOwnProps } from '@src/components/common/localize/withLocalize';
import withRoles, { IWithRolesOwnProps } from '@src/components/common/role/withRoles';
import withTenantPropEnabled, { IWithTenantPropEnabledOwnProps } from '@src/components/tenant/withTenantPropEnabled';
import { Empty } from 'antd';
import React from 'react';

interface IAdminEducationSectorPageOwnProps { }

type IAdminEducationSectorCodebookPageProps = IWithRolesOwnProps & IWithTenantPropEnabledOwnProps & IWithLocalizeOwnProps;

// -- Component
// ----------

const AdminEducationSectorCodebookPage = (props: IAdminEducationSectorCodebookPageProps) => {
  const DisplayComponent = (props.isSuperAdmin() || props.isTenantPropEnabled('codebook_education_sector')) ? <EducationSectorCodebookContainer /> : <Empty description={props.translate('COMMON.LABEL.NOT_ALLOWED_TO_ACCESS')} />;
  return (
    <React.Fragment>
      {DisplayComponent}
    </React.Fragment>
  );
};

export default withTenantPropEnabled<IAdminEducationSectorPageOwnProps>(withLocalize(withRoles(AdminEducationSectorCodebookPage as any)));
